
/* ============================== src/context/ToastContext.js ============================== */
// src/context/ToastContext.js
import { createContext, useContext } from "react";

export const ToastContext = createContext(null);

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
};
